<script setup>
defineProps({
  year: String,
  project: String,
  yearOptions: {
    type: Array,
    default: () => [],
  },
  projectOptions: {
    type: Array,
    default: () => [],
  },
});

defineEmits(["update:year", "update:project"]);
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 mb-4">
    <div class="card-body p-4">
      <div class="row g-3 align-items-end">
        <div class="col-lg-4">
          <label class="form-label fw-semibold text-secondary">ปีรายงาน</label>
          <select
            class="form-select"
            :value="year"
            @change="$emit('update:year', $event.target.value)"
          >
            <option v-for="item in yearOptions" :key="item" :value="item">
              {{ item }}
            </option>
          </select>
        </div>

        <div class="col-lg-4">
          <label class="form-label fw-semibold text-secondary">โครงการ</label>
          <select
            class="form-select"
            :value="project"
            @change="$emit('update:project', $event.target.value)"
          >
            <option
              v-for="item in projectOptions"
              :key="item.value"
              :value="item.value"
            >
              {{ item.label }}
            </option>
          </select>
        </div>

        <div class="col-lg-4">
          <div class="alert alert-light border rounded-4 py-2 px-3 mb-0 small">
            <i class="bi bi-info-circle me-2 text-primary"></i>
            รายงานในหน้านี้เป็นข้อมูลจำลองจาก Store สำหรับใช้พัฒนา UI และ Flow
            การใช้งาน
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
